import MyAccount from '../../../components/account/myAccount/MyAccount';

const MyAccountPage = () => {
  return <MyAccount />;
};

export default MyAccountPage;
